// extracted by mini-css-extract-plugin
export var deliveryRow = "_sy-a";
export var fixedHeight = "_sy-4";
export var freightLogo = "_sy-9";
export var fullWidth = "_sy-3";
export var priceColumn = "_sy-5";
export var radioSelected = "_sy-7";
export var radioUnselected = "_sy-6";
export var selectedOption = "_sy-2";
export var selectedOptionContainer = "_sy-1";
export var selection = "_sy-0";
export var tallSkeletonText = "_sy-8";